var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-img"},[_c('img',{attrs:{"src":require("@/assets/img/errorImg/error403.jpg"),"alt":""}})]),_c('p',{staticClass:"error-msg"},[_vm._v("您缺少使用此功能的相应权限，请联系公司管理员申请。")])])
}]

export { render, staticRenderFns }